import React, { useCallback, useEffect, useState } from "react";
import loginImage from "../../assets/images/login.png";
import LogoWhite from "../../assets/images/LogoWhite.svg";
import infocircle from "../../assets/images/infocircle.svg";
import PrimecareLogo from "../../assets/images/PrimecareLogo.svg";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCommonMessage } from "../../common/CommonMessage";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
  handleKeyPressSpace,
  // handleNumberFieldLength,
  handleSSNNumberFieldLength,
} from "../../common/CommonFunctions";
import moment from "moment";
import { STATUS_CODE } from "../../common";
import Loader from "../Loder/loader";
import { loginValidationSsnIdSchema } from "../Login/LoginValidation";
import {
  guestUserLoginHandler,
  guestUserLoginSliceAction,
} from "../../redux/action/guestUserAction/guestUserLogin";
import {
  getCurrentStepsHandler,
  getCurrentStepsSliceAction,
} from "../../redux/action/guestUserAction/getCurrentSteps";
import {
  GUEST_EDUCATIONAL_BACK_DEFAULT,
  GUEST_EDUCATIONAL_BACK_STORAGE_KEY,
  GUEST_ENROLLMENT_PATHS,
  guestEnrollmentPathFromStep,
  normalizeGuestStepKey,
} from "../../common/guestEnrollmentFlow";

/** Decrypted API body is stored as slice `data`; status/step may be nested or string-typed. */
function readGuestApiStatusCode(payload) {
  if (!payload || typeof payload !== "object") return NaN;
  const raw =
    payload.statusCode ??
    payload.StatusCode ??
    payload?.data?.statusCode ??
    payload?.data?.StatusCode;
  if (raw === undefined || raw === null) return NaN;
  const n = Number(raw);
  return Number.isFinite(n) ? n : NaN;
}

function isGuestCurrentStepSuccess(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.error === true || payload.Error === true) return false;
  if (readGuestApiStatusCode(payload) === STATUS_CODE.OK) return true;
  if (payload.success === true || payload.Success === true) {
    return !!readEnrollmentCurrentStep(payload);
  }
  return false;
}

function readEnrollmentCurrentStep(payload) {
  if (!payload || typeof payload !== "object") return undefined;
  const candidates = [
    payload.currentStep,
    payload.CurrentStep,
    payload?.data?.currentStep,
    payload?.data?.CurrentStep,
    payload?.data?.data?.currentStep,
    payload?.data?.data?.CurrentStep,
  ];
  for (const c of candidates) {
    if (c !== undefined && c !== null && String(c).trim() !== "") {
      return String(c).trim();
    }
  }
  return undefined;
}

const OpenEnrollment = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const messageApi = useCommonMessage();
  const [loginContext, setLoginContext] = useState(null);

  const guestUserLoginSelector = useSelector((state) => state?.guestUserLogin);
  const getCurrentStepsSelector = useSelector(
    (state) => state?.getCurrentSteps,
  );
  const handleFormSubmit = (values) => {
    const payload = {
      ssn: values?.ssnId,
      dob: values?.dateOfBirth,
      deviceType: "COMMON",
      deviceId: "12324",
      fcmToken: "23e24324",
      modelName: "S3-9889",
      deviceName: "Samsung s4",
      brand: "Samsung",
    };
    setLoginContext({
      ssn: payload.ssn,
      dob: payload.dob,
    });
    dispatch(guestUserLoginHandler(payload));
  };

  const handleRedirect = useCallback((enumType) => {
    return guestEnrollmentPathFromStep(enumType);
  }, []);
  useEffect(() => {
    // dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
    dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    try {
      window.sessionStorage?.removeItem(GUEST_EDUCATIONAL_BACK_STORAGE_KEY);
    } catch {
      // ignore
    }
  }, [dispatch]);

  useEffect(() => {
    const statusCode = guestUserLoginSelector?.data?.statusCode;
    const responseMessage = guestUserLoginSelector?.data?.message;
    const multipleMembers = guestUserLoginSelector?.data?.data?.multipleMembers;
    const memberCount = multipleMembers?.length ?? 0;

    if (
      statusCode === STATUS_CODE.OK &&
      (multipleMembers == null || memberCount === 0)
    ) {
      messageApi.open({
        type: "success",
        content: responseMessage,
      });

      dispatch(getCurrentStepsHandler());

      dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    } else if (memberCount > 0) {
      navigate("/guest-user/number-listing", {
        state: { multipleMembers, loginContext },
      });
      dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    } else if (
      statusCode === STATUS_CODE.NOT_FOUND ||
      statusCode === STATUS_CODE.BAD_REQUEST ||
      statusCode === STATUS_CODE.UNAUTHORIZED ||
      statusCode === STATUS_CODE.FORBIDDEN
    ) {
      messageApi.open({
        type: "error",
        content: responseMessage,
      });
      dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    } else if (guestUserLoginSelector?.message) {
      messageApi.open({
        type: "error",
        content: guestUserLoginSelector?.message,
      });
      dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    }
  }, [guestUserLoginSelector, dispatch, messageApi, navigate, loginContext]);

  useEffect(() => {
    if (
      getCurrentStepsSelector?.isLoading ||
      getCurrentStepsSelector?.data ||
      !getCurrentStepsSelector?.message
    ) {
      return;
    }
    messageApi.open({
      type: "error",
      content: getCurrentStepsSelector.message,
    });
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
  }, [getCurrentStepsSelector, messageApi]);

  useEffect(() => {
    if (getCurrentStepsSelector?.isLoading) {
      return;
    }

    const payload = getCurrentStepsSelector?.data;
    if (!isGuestCurrentStepSuccess(payload)) {
      return;
    }

    const step = readEnrollmentCurrentStep(payload);
    const route = step ? handleRedirect(step) : "/guest-user/open-enrollment";

    const stepKey = normalizeGuestStepKey(step);
    const navOpts = { replace: true };
    // EducationalContentESign redirects to /enrollment unless enrollment was accepted.
    if (stepKey === "ENROLLMENT_AGGREMENT") {
      navOpts.state = { enrollmentDecision: "yes" };
    }
    if (stepKey === "ENROLLMENT_DECLINED") {
      navOpts.state = { enrollmentDecision: "no" };
    }
    if (stepKey === "COMPLETED") {
      navOpts.state = { enrollmentDecision: "yes" };
    }
    if (stepKey === "ENROLLMENT_ESIGN_COMPLETED") {
      navOpts.state = { enrollmentDecision: "yes" };
    }
    // Login uses replace:true, so history back is unreliable; educational header needs an explicit parent.
    if (route === GUEST_ENROLLMENT_PATHS.educational) {
      navOpts.state = {
        ...navOpts.state,
        guestEducationalBackTo: GUEST_EDUCATIONAL_BACK_DEFAULT,
      };
    }

    dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
    navigate(route, navOpts);
  }, [getCurrentStepsSelector, handleRedirect, navigate, dispatch]);

  // useEffect(() => {
  //   if (getCurrentStepsSelector?.data?.statusCode === STATUS_CODE.OK) {
  //     if (getCurrentStepsSelector?.data?.data) {
  //       const route = handleRedirect(
  //         getCurrentStepsSelector?.data?.data?.currentStep,
  //       );
  //       dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
  //       navigate(route);
  //     } else {
  //       dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
  //       navigate("/guest-user/open-enrollment");
  //     }
  //   }
  // }, [getCurrentStepsSelector, handleRedirect, navigate]);

  // const navigateToSupportRequest = () => {
  //   navigate("/support-request");
  // };

  return (
    <>
      {guestUserLoginSelector?.isLoading && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="loginFlex pc">
        <div className="w-50 h-100 position-relative mobileHide">
          <img src={loginImage} alt="" className="w-100 h-100 object-cover" />
          <img src={LogoWhite} alt="" className="loginLogo" />
          <div className="loginText">
            <h2 className="fs-32 text-white fw-700">
              {t("Prime Care")}{" "}
              <span className="fs-28 text-white fw-300 gbo">
                {t("Provides")} {t("Nationwide")} <br />{" "}
                {t("Direct Primary Care")}
              </span>
            </h2>
          </div>
        </div>
        <div className="d-flex align-center justify-center w-lg-50 loginside">
          <div className="mx-420 mx-auto">
            <div className="text-center mb-40 mobileShow">
              <img src={PrimecareLogo} alt="" />
            </div>
            <h1 className="fs-36 mb-8 text-lg-center tgb">{t("Login")}</h1>
            <h2 className="fs-28 mb-40 text-lg-center tgb">
              {t("to complete the Education")}
            </h2>

            <Formik
              initialValues={{
                ssnId: "",
                dateOfBirth: null,
              }}
              validationSchema={loginValidationSsnIdSchema(t)}
              onSubmit={handleFormSubmit}
            >
              {({ setFieldValue }) => (
                <Form>
                  <div className="mb-40">
                    <div className="mb-20">
                      <h2 className="fs-16 mb-10">{t("Last four digits of SSN")}</h2>
                      <Field
                        type="text"
                        className="inputField mb-10"
                        // placeholder={t("SSN ID")}
                        placeholder={t("Last four digits of SSN")}
                        name="ssnId"
                        onKeyPress={handleKeyPressSpace}
                        onInput={(event) => handleSSNNumberFieldLength(event)}
                        maxLength={4}
                        autoComplete="off"
                        onKeyDown={(event) => {
                          if (
                            event.key === "ArrowUp" ||
                            event.key === "ArrowDown"
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <div
                        className="fs-14 fw-500 gap-4 lineheight-18 d-flex align-items-center"
                        style={{ color: "#8697B1" }}
                      >
                        <img src={infocircle} alt="" />
                        XXX-XX-“1234”
                      </div>
                      <ErrorMessage
                        name="ssnId"
                        component="div"
                        className="fs-14 error-message"
                      />
                    </div>
                    <div className="mb-40">
                      <h2 className="fs-16 mb-10">{t("Enter your DOB")}</h2>
                      <DatePicker
                        className="datepicker"
                        placeholder={t("MM/DD/YYYY")}
                        onChange={(date, dateString) => {
                          setFieldValue("dateOfBirth", dateString);
                        }}
                        format="MM/DD/YYYY"
                        name="dateOfBirth"
                        disabledDate={(current) => {
                          return current && current > moment().endOf("day");
                        }}
                      />
                      <ErrorMessage
                        name="dateOfBirth"
                        component="div"
                        className="fs-14 error-message"
                      />
                    </div>
                  </div>
                  <button
                    className="primaryButton w-100 mb-30 cursor-pointer fs-18"
                    type="submit"
                  >
                    {t("Continue")}
                  </button>
                  <div className="text-center mb-40">
                    {t("Already a member?")}{" "}
                    <span
                      onClick={() => navigate("/login")}
                      className="primaryColor cursor-pointer underline"
                    >
                      {t("Login")}
                    </span>
                  </div>
                </Form>
              )}
            </Formik>
            {/* <div className="mb-30 text-lg-center text-center">
              {t("By Signing in you agree to our")}{" "}
              <span
                className="gm cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://primecaregs.com/notice-of-privacy-practices-for-primecare/",
                    "_blank",
                  )
                }
              >
                {t("Privacy Policy")}
              </span>
            </div>
            <div
              className="text-center text-underline text-underline cursor-pointer"
              onClick={navigateToSupportRequest}
            >
              {t("Having trouble signing in?")}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenEnrollment;
